import React from "react";
import HousingForm from "./HousingForm";

interface AddressProps {
  governorates: any;
  form : any;
}

const AddressData = ({ governorates ,form}: AddressProps) => {
  return (
    <div style={{ marginTop: "-10vh", padding: "2rem" }}>
      <HousingForm governorates={governorates} form={form} />
    </div>
  );
};

export default AddressData;
